import FeedLargeVideoPost from './components/FeedLargeVideoPost';
import FeedPlaylist from './components/FeedPlaylist';
import FeedPlaylistTrack from './components/FeedPlaylistTrack';
import FeedPostStyle, {
  FEED_ALBUM_THUMB_PORTRAIT,
} from './components/FeedPostStyle';

export const Feeds = () => {
  return (
    <div id="feeds-content">
      <div className="w-full pb-[220px] pt-[10px] sm:m-auto sm:max-w-[500px]">
        <FeedPostStyle
          widthHeight="w-[200px] h-[200px]"
          data={{
            name: 'Daniel Kim',
            username: '@DanielKim',
            time: 'now',
            category: 'album',
            description:
              'A futuristic blend of electropop and synth-pop from Daniel.',
            postImage:
              'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/4ae850bf-44ea-4278-bb76-0f4d7fa86d15/albums/01fba7f2-bac1-4c05-b62a-061963cec23d/01fba7f2-bac1-4c05-b62a-061963cec23d.jpg',
            likes: '4.1K',
            comments: '3.2K',
            saved: '1.6K',
            albumName: 'Future Bloom',
            contributorImage:
              'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/4ae850bf-44ea-4278-bb76-0f4d7fa86d15/4ae850bf-44ea-4278-bb76-0f4d7fa86d15.jpg',
            albumId: '01fba7f2-bac1-4c05-b62a-061963cec23d',
          }}
          bgStyle="bg-[linear-gradient(180deg,rgba(97,244,255,0.2)_0%,rgba(97,244,255,0)_100%)]"
        />
        <FeedPostStyle
          widthHeight={FEED_ALBUM_THUMB_PORTRAIT}
          data={{
            name: 'Nia Jenkins',
            username: '@NiaJenkins',
            time: 'now',
            category: 'album',
            description:
              'A powerful collection of conscious hip-hop tracks from Nia Jenkins star.',
            postImage:
              'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/8262809e-3d84-4e73-8349-ccba5977f41c/albums/c97ef7b7-907e-47ee-bf73-f5834568bdf0/c97ef7b7-907e-47ee-bf73-f5834568bdf0.jpg',
            likes: '4.1K',
            comments: '3.2K',
            saved: '1.6K',
            albumName: 'Concrete Rose',
            contributorImage:
              'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/1c8ec896-caa8-462a-98a4-74d733cd0f9e/1c8ec896-caa8-462a-98a4-74d733cd0f9e.jpg',
            albumId: 'c97ef7b7-907e-47ee-bf73-f5834568bdf0',
          }}
          bgStyle="bg-[linear-gradient(180deg,rgba(255,222,120,0.2)_0%,rgba(255,222,120,0)_100%)]"
        />
        <FeedLargeVideoPost />
        <FeedPlaylist />
        <FeedPlaylistTrack />
        <FeedPostStyle
          widthHeight="w-[200px] h-[200px]"
          data={{
            name: 'Isabelle Moreau',
            username: '@isabelle.moreau',
            time: 'now',
            category: 'album',
            description:
              'Electrifying pop anthems with radiant energy and summer vibes.',
            postImage:
              'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/ea834df9-2662-42ef-9373-bdce2c601071/albums/b7015c30-fefd-4df2-8085-d34f66d6d39c/b7015c30-fefd-4df2-8085-d34f66d6d39c.jpg',
            likes: '4.1K',
            comments: '3.2K',
            saved: '1.6K',
            albumName: 'Radiant',
            contributorImage:
              'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/ea834df9-2662-42ef-9373-bdce2c601071/ea834df9-2662-42ef-9373-bdce2c601071.jpg',
            albumId: 'b7015c30-fefd-4df2-8085-d34f66d6d39c',
          }}
          bgStyle="bg-[linear-gradient(180deg,rgba(97,244,255,0.2)_0%,rgba(97,244,255,0)_100%)]"
        />
      </div>
    </div>
  );
};
